const $ = require('jquery');
let _ = require('lodash');

'use strict';

const PLUGIN_NAME = 'redirectForm';

const DEFAULTS = { 
  debug: false, // v debug rezimu se data neodesilaji, jen se zobrazuji v konzoli
  fragments: {
    FG_RDU_RESULT: '[data-fragment="rdu.result.ele"]',
  },
};

/**
 * plugin constructor
 * @param element
 * @param options
 * @constructor
 */
function RedirectForm(element, options) {
  this.element = element;
  this.$body = $(this.element);

  this.options = $.extend(true, {}, DEFAULTS, options);

  this._defaults = DEFAULTS;
  this._name = PLUGIN_NAME;

  this.initialise();
}

/**
 * inicializace
 */
RedirectForm.prototype.initialise = function () {
  const self = this;

  self.bindEvents();
};

/**
 * nabindovani udalosti
 */
RedirectForm.prototype.bindEvents = function () {
  const self = this;

  // this.logger_('Debug režim - bindEvents', self);

  // po výměně obsahu PU načte data object ze kterého si vezme URL pro přesměrování
  $(document).on('afterContentsReplaced', (e) => {
    self.afterContentsReplaced(e);
  });

};

/**
 * Provede akci po výměně obsahu pomocí PU
 * @info Pokusí se najít prvek obsahující nasetovaná data ze kterých by mohl sestavit push. Pokud najde tak podle atributu push pustí příslušnou akci.
 * @param event
 */
RedirectForm.prototype.afterContentsReplaced = function (event) {
  let self = this,
    o = this.options,
    $data = {},
    $r = $(o.fragments.FG_RDU_RESULT, $(event.target));


  if ($r.length > 0) {
      $data = $r.data('rdu');
      self.onRedirect_($data);
  }
};

/**
 * Provede vystřelení eventu po odeslání Leadového formuláře a provede přesměrování na požadovanou URL
 * @param dSet
 * @private
 */
RedirectForm.prototype.onRedirect_ = function (dSet) {
  let self = this,
    o = this.options;

  if (dSet.urlRedirect) {
    window.location.replace(dSet.urlRedirect.replace(/xxx/g, '&'));
  }
};

/**
 * simple logger
 */
RedirectForm.prototype.logger_ = function (...args) {
  if (window.console && this.options.debug) {
    console.group('Debug of RedirectForm');
    Object.values(args).forEach(value => console.log(value));
    console.groupEnd();
  }
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  const args = arguments;


  return this.each(function () {
    const $this = $(this);

    // get plugin instance
    let plugin = $this.data(`plugin_${PLUGIN_NAME}`);

    // if there's not, create one
    if (!plugin) {
      plugin = new RedirectForm(this, value);
      $this.data(`plugin_${PLUGIN_NAME}`, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value](...Array.prototype.slice.call(args, 1));
    }
  });
};



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/jquery.redirectForm.js